import { get, put, del, post } from './client.js';
import { auth } from '../auth/firebase.js';

async function downloadBlob(path, fallbackName) {
    const user = auth.currentUser;
    const headers = {};
    if (user) headers['Authorization'] = `Bearer ${await user.getIdToken()}`;
    const r = await fetch(path, { headers, credentials: 'same-origin' });
    if (!r.ok) {
        const text = await r.text().catch(() => '');
        throw new Error(text || `${r.status} ${r.statusText}`);
    }
    // 從 Content-Disposition 抓檔名
    let name = fallbackName;
    const cd = r.headers.get('Content-Disposition') || '';
    const m = cd.match(/filename="?([^";]+)"?/i);
    if (m) name = m[1];
    const blob = await r.blob();
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = name;
    document.body.appendChild(a);
    a.click();
    a.remove();
    setTimeout(() => URL.revokeObjectURL(url), 1000);
}

export const tenantsApi = {
    list: () => get('/api/ivr/admin/tenants'),
    get: (hostId) => get(`/api/ivr/admin/tenants/${encodeURIComponent(hostId)}`),
    upsert: (hostId, body) => put(`/api/ivr/admin/tenants/${encodeURIComponent(hostId)}`, body),
    remove: (hostId) => del(`/api/ivr/admin/tenants/${encodeURIComponent(hostId)}`),
    registrations: (hostId) =>
        get(`/api/ivr/admin/tenants/${encodeURIComponent(hostId)}/registrations`),
    quota: (hostId) =>
        get(`/api/ivr/admin/tenants/${encodeURIComponent(hostId)}/quota`),
    // 付費角色數用量（跨母帳號所有 tenant、分 AA/CS 兩池）— 新增角色前的額度檢查。
    // ⚠️ 別拿 quota() 的 avatarUsed 去比 roleQuota：那個只算本 tenant，同帳號多 tenant 會少算。
    roleUsage: (hostId) =>
        get(`/api/ivr/admin/tenants/${encodeURIComponent(hostId)}/role-usage`),
    probePbx: (hostId) =>
        post(`/api/ivr/admin/tenants/${encodeURIComponent(hostId)}/probe-pbx`),
};

// DID / sipPhoneNumbers — inbound trunk → avatar 對應
export const didApi = {
    listByHost: (hostId) =>
        get(`/api/ivr/admin/tenants/${encodeURIComponent(hostId)}/dids`),
    upsert: (hostId, phoneNumber, body) =>
        put(
            `/api/ivr/admin/tenants/${encodeURIComponent(hostId)}/dids/${encodeURIComponent(phoneNumber)}`,
            body
        ),
    remove: (hostId, phoneNumber) =>
        del(
            `/api/ivr/admin/tenants/${encodeURIComponent(hostId)}/dids/${encodeURIComponent(phoneNumber)}`
        ),
};

export const avatarsApi = {
    listForTenant: (hostId) =>
        get(`/api/ivr/admin/avatars?hostId=${encodeURIComponent(hostId)}`),
};

const hq = (hostId) => (hostId ? `?hostId=${encodeURIComponent(hostId)}` : '');

export const planApi = {
    me: () => get('/api/ivr/admin/me/plan'),
    // hostId：算「目前租戶擁有者」的分鐘數（被邀進來的員工 / 經銷商才看得到正確額度）
    minuteBalance: (hostId) => get(`/api/ivr/admin/me/minute-balance${hq(hostId)}`),
    usageAlert: (hostId) => get(`/api/ivr/admin/me/usage-alert${hq(hostId)}`),
    saveUsageAlert: (hostId, body) => put(`/api/ivr/admin/me/usage-alert${hq(hostId)}`, body),
    testUsageAlert: (hostId) => post(`/api/ivr/admin/me/usage-alert/test${hq(hostId)}`, {}),
    list: () => get('/api/ivr/admin/plans'),
};

export const outboundApi = {
    start: (hostId, body) =>
        post(`/api/ivr/admin/tenants/${encodeURIComponent(hostId)}/outbound`, body),
    status: (hostId, jobId) =>
        get(`/api/ivr/admin/tenants/${encodeURIComponent(hostId)}/outbound/${encodeURIComponent(jobId)}`),
};

// 診斷：運行記錄 + 租戶診斷封包下載
export const diagnosticApi = {
    status: () => get('/api/ivr/admin/diagnostic/status'),
    toggle: (enable, ttlMinutes = 30) =>
        post('/api/ivr/admin/diagnostic/toggle', { enable, ttlMinutes }),
    logs: (sinceSeq = 0, limit = 500) =>
        get(`/api/ivr/admin/diagnostic/logs?sinceSeq=${sinceSeq}&limit=${limit}`),
    dumpTenant: (hostId, period = '24h') =>
        downloadBlob(
            `/api/ivr/admin/tenants/${encodeURIComponent(hostId)}/logs/dump?period=${encodeURIComponent(period)}`,
            `${hostId}-diagnostic.zip`
        ),
};
